import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Pipe,
  PipeTransform,
  ViewContainerRef,
} from '@angular/core';
import { Operation } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { isPrimitive } from '@epicuro-next/utilities';
import { of } from 'rxjs';

import { LogicOperationsService } from '../services/logic-operations.service';
/**
 * Time from now pipe.
 */
@Pipe({
  name: 'dynamicOperationIf',
  pure: false,
  standalone: false,
})
export class DynamicOperationIfPipe implements PipeTransform {
  private asyncPipe: AsyncPipe;

  constructor(
    private lo: LogicOperationsService,
    private cdr: ChangeDetectorRef,
    private vcRef: ViewContainerRef,
  ) {
    this.asyncPipe = new AsyncPipe(this.cdr);
  }

  public transform(value: Operation | boolean) {
    let obj;

    if (value === undefined || value === null) {
      obj = of(false);
    } else if (isPrimitive(value)) {
      obj = of(value);
    } else {
      obj = this.lo.performOperationCheck(
        value as Operation,
        this.vcRef.injector,
      );
    }

    return this.asyncPipe.transform(obj);
  }
}
